module.exports = __webpack_public_path__ + "img/intro-en.6740969f.jpg";